import request from '@/util/request';
import qs from 'qs';

export const getDetail = (params, options) =>
  request.get('/api/v4ward/department/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/base/property/removeCommunity', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/base/property/saveCommunity', params, options);

export const update = (params, options) =>
  request.post('/api/base/property/updateCommunity', params, options);

export const getOneDepartmentDetail = (params, options) =>
  request.get('/api/v4ward/department/getOneDepartmentDetail', Object.assign({}, options, { params }));

export const getCommunityPage = (params, options) =>
  request.get('/api/base/property/getCommunityPage', Object.assign({}, options, { params }));

//此处获取的是字典排序后的结果
export const getDictList = (params, options) =>
  request.get('/api/base/property/getSortUseTypes', Object.assign({}, options, { params }));

//项目下拉框
export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取所属部门下拉框数据
export const treeByProjectDeptId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));
